import request from '@/utils/request'

export function loginByPwd(data) {
  return request({
    url: '/api/login/byPwd',
    method: 'post',
    params:data
  })
}

export function loginByTokenApi(data) {
  return request({
    url: '/api/login/byToken',
    method: 'post',
    params:data
  })
}

export function loginByPhone(data) {
  return request({
    url: '/api/login/byPhone',
    method: 'post',
    params:data
  })
}

export function loginByEmail(data) {
  return request({
    url: '/api/login/byEmail',
    method: 'post',
    params:data
  })
}

export function getInfo(token) {
  return Promise.resolve({
    code: 20000,
    data: {
      roles: ['admin'],
      introduction: 'I am a super administrator',}})
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/api/logout',
    method: 'get'
  })
}

export function sendPhoneVerifyCode(data) {
  return request({
    url: '/api/send/code/phone',
    method: 'post',
    params:data
  })
}

// sendPhoneVerifyCodeNew
export function sendPhoneVerifyCodeNew(data) {
  return request({
    url: '/api/captcha/verify',
    method: 'post',
    data
  })
}

export function sendEmailVerifyCode(data) {
  return request({
    url: '/api/send/code/email',
    method: 'post',
    params:data
  })
}

export function registerApi(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data:data
  })
}

export function venueListApi(data) {
  return request({
    url: '/api/venue/list',
    method: 'get',
    params:data
  })
}

export function updateVenueCodeApi(data) {
  return request({
    url: '/api/check/update/venue',
    method: 'post',
    data:data
  })
}

export function userUpdateOneselfPwd(data) {
  return request({
    url: '/api/sys/user/update/oneself/pwd',
    method: 'post',
    data:data
  })
}

// resetPasswordApi
export function resetPasswordApi(data) {
  return request({
    url: '/api/reset/pwd/byPhone',
    method: 'post',
    data:data
  })
}